module.exports = __webpack_public_path__ + "static/img/avatar-2.02aea0c2.jpg";